export default "__VITE_ASSET__61d59e7c__"